import { render } from "./AvatarWithEditor.vue?vue&type=template&id=6cf25151"
import script from "./AvatarWithEditor.vue?vue&type=script&lang=js"
export * from "./AvatarWithEditor.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__